import React, { useState } from 'react';
import {
    TextField,
    InputAdornment,
    IconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const PasswordField = ({
    label,
    value,
    onChange,
    onBlur,
    error,
    helperText,
    fieldName,
    form,
    ...otherProps
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const formValues = form?.values || {};
    const setFieldValue = form?.setFieldValue || (() => {});
    const handleBlur = form?.handleBlur;

    const isTouched = Boolean(form?.touched?.[fieldName]);
    const formErrorMessage = isTouched ? form?.errors?.[fieldName] : null;
    const resolvedErrorMessage = formErrorMessage || (isTouched && typeof helperText === 'string' ? helperText : null);
    const hasError = Boolean(formErrorMessage || (isTouched && error));

    const handleTogglePassword = () => {
        setShowPassword(prev => !prev);
    };

    const handlePasswordChange = (event) => {
        setFieldValue(fieldName, event.target.value);
        if (onChange) {
            onChange(event);
        }
    };

    const handlePasswordBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        if (handleBlur) {
            handleBlur(event);
        }
    };

    return (
        <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id={fieldName}
            label={label}
            type={showPassword ? 'text' : 'password'}
            value={formValues[fieldName] ?? value ?? ''}
            onChange={handlePasswordChange}
            onBlur={handlePasswordBlur}
            error={hasError}
            helperText={hasError ? resolvedErrorMessage : ''}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword}>
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
            {...otherProps}
        />
    );
};